
define('jst!tasks/tour/_step8',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<h1><%= t("Task reminders #tasksfeaturetour") %></h1>\n<p><%= t("Got an important task coming up? Choose to be reminded up to 24 hours before. You will receive a notification in your Podio inbox and an email depending on your notification settings. Also, you\'ll get push notifications sent to your Android or iPhone. #tasksfeaturetour") %></p>\n');
 });

